import { render, staticRenderFns } from "./ONama.vue?vue&type=template&id=3211c4e6"
import script from "./ONama.vue?vue&type=script&lang=js"
export * from "./ONama.vue?vue&type=script&lang=js"
import style0 from "./ONama.vue?vue&type=style&index=0&id=3211c4e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports